const shopDictIT = {
  seeProduct: "Vedi prodotto",
  firstBannerText: "Il marketplace che ti premia sempre",
  secondaryBannerText: "Unisciti all'Extraconomy",
  secondaryBannerButtonText: "Scopri i nostri piani",
  secondaryBannerText2: "Aumenta il tuo potere economico",
  searchQueryText: "Tu hai cercato per: ",
  subCategoryFilter: "Sottocategorie",
  noProductsInCategory: "Non ha prodotti",
  noProductsInSearch: "Nessun prodotto trovato",
  noSubcategories: "Non ha sottocategorie",
  filters: "Filtri",
  downloadable: "Scaricabile",
  brazil: "Brasile",
  mexico: "Messico",
  italy: "Italia",
  brl: "BRL",
  mxn: "MXN",
  eur: "EUR",
  usd: "USD",
  gbp: "GBP",
  try: "TRY",
  results: "Risultati",
  result: "Risultato",
  selectStore: "Seleziona un negozio",
  store: "Negozio",
  filter: "Filtro",
  registerAsCustomerFree: "Registrati come Customer gratuitamente",
  register2: "Registrati",
  selectCategory: "Seleziona il Reparto",
  allDepartments: "Tutti i Reparti",
  departments: "Reparti",
  discoverAllDepartments: "Scopri tutti i nostri reparti",
  seeBellowAllDepartments:
    "Vedi qui tutti i nostri reparti disponibili nella negozio e filtra prodotti per il tuo reparto preferito.",
  linkCopied: "Link copiato",
  errorCopyingLink: "Errore durante la copia del link",
  sharedSuccessfully: "Condiviso con successo",
  promoterBadge: "Guadagna {percent}%",
  promoterBadgeTitle: "Condividi il tuo link e guadagna il {percent}% di commissione su ogni vendita",
  promoterShareTitle: "Guadagna il {percent}% di commissione condividendo",
  promoterShareDescription: "Genera il tuo link e condividilo. Per ogni acquisto fatto tramite il link ricevi il {percent}% del valore del prodotto nel tuo portafoglio quando l'ordine viene ricevuto.",
  promoterGenerateLink: "Genera il mio link",
  promoterCopyLink: "Copia link",
  promoterShareAction: "Condividi",
  promoterLinkError: "Non è stato possibile generare il tuo link. Riprova.",
  sharingCanceled: "Condivisione annullata",
  errorSharing: "Errore durante la condivisione",
  findPartnersNearYou: "Trova i venditori Extraconomy vicino a te",
  findBusinessSquarePartnersNearYou: "Trova i venditori {subnetName} vicino a te",
  useOurMap:
    "Scopri aziende, servizi e prodotti che fanno parte della nuova economia del benessere. Utilizza la mappa per localizzare i venditori nelle vicinanze, usufruire dei vantaggi e favorire la circolarità finanziaria intorno a te.",
  buyLocally:
    "Acquistando da venditori vicini, rafforzi l'economia locale, accumuli ricompense e partecipi a una rete più equa per tutti.",
  value: "Valore",
  bank: "Banca",
  transferToThisBank: "Devi effettuare la transferenza con i seguenti dati:",
  fringeBenefits: "Flexible Benefits",
  readMore: "Scopri di piu'",
  fringeBenefit: "Flexible Benefit",
  myCards: "Fidelity Card",
};

export default shopDictIT;
